export default __webpack_public_path__ + "static/media/4.06688a78.png";